import { API } from '~apis/axios/instance';
import { ResponseBase } from '~types/response';

export interface BusinessRegistrationNumberInfo {
  businessRegNumber: string;
  companyName?: string | null;
}

export interface GetBusinessRegistrationNumbersResponse extends ResponseBase {
  data: {
    businessRegNumbers: BusinessRegistrationNumberInfo[];
  };
}

export const getBusinessRegistrationNumbers = (companyId: string) => {
  return API.get<GetBusinessRegistrationNumbersResponse>(
    `/api/v3/companies/${companyId}/business-registration-numbers`,
  );
};
